import { NgModule } from '@angular/core'
import { PictureComponent } from './picture.component'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { LazyLoadImageModule } from 'ng-lazyload-image'
import { ImageSize } from '../../../enums/image-size'
import { MediaQueries } from '../../../enums/media-queries'

@NgModule({
  declarations: [
    PictureComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    LazyLoadImageModule
  ],
  exports: [
    PictureComponent
  ]
})
export class PictureModule {
}

export interface SrcSet {
  mediaQuery: MediaQueries;
  src?: ImageSize;
  url1x?: string;
  url2x?: string;
  noWebp?: boolean;
}

